module.exports = __webpack_public_path__ + "img/190.dirty_stairs.631f1d9e.svg";